import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  InputLabel,
  Button,
  Chip,
  CircularProgress,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import VedioDialog from "./VedioDialog";
import { BACKEND_BASE_URL } from "../../config";
import ShowMappingDialog from "../dashboard/components/Table/ShowMappingDialog";

const useStyles = makeStyles((theme) => ({
  headerCell: {
    fontWeight: "bold",
    backgroundColor: "#152F8F", // Set header background color
    color: "white", // Set header text color
    border: "1px solid #ddd", // Add border to header cells
  },
  header: {
    position: "sticky",
    top: 0,
    backgroundColor: "#152F8F",
    color: "white",
    zIndex: 1000, // Ensures header stays above body content
  },
  tableBodyWrapper: {
    maxHeight: "calc(100vh - 200px)", // Adjust based on header height
    overflowY: "auto", // Allows vertical scrolling of table body
    position: "relative",
    "&::-webkit-scrollbar": {
      width: "0px", // Hides scrollbar
      background: "transparent",
    },
  },
  table: {
    border: "1px solid #ddd", // Add border to the entire table
    minWidth: "1000px", // Ensures the table is wider than the screen
  },
  tableContainer: {
    position: "relative", // Ensures relative positioning
    width: "100%",
    height: "calc(100vh - 150px)", // Adjust height to fit within the viewport
    display: "flex",
    flexDirection: "column",
  },

  tableWrapper: {
    marginBottom: theme.spacing(2),
    flexGrow: 1, // Makes it expand within the container
    overflowX: "auto", // Allows horizontal scrolling
    overflowY: "auto", // Allows vertical scrolling
    position: "relative", // Ensures proper positioning


  },

  scrollbarContainer: {
    position: "fixed", // Fixes the scrollbar at the bottom
    bottom: 0, // Keeps it at the bottom of the screen
    left: 0,
    width: "100%",
    backgroundColor: "#fff", // Optional: background color for visibility
    borderTop: "1px solid #ddd",
    padding: "5px 0",
    zIndex: 1000, // Ensures it stays above other elements
  },
  scrollbar: {
    width: "100%",
    overflowX: "scroll",
  },

  chip: {
    margin: "2px",
    backgroundColor: "#152F8F",
    color: "white",
  },
  responsiveTable: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem", // Adjust font size for smaller screens
    },
  },
  responsiveCell: {
    border: "1px solid #ddd",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.75rem", // Adjust cell font size for smaller screens
      padding: "4px", // Reduce padding for smaller screens
    },
  },
  responsiveButton: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.7rem", // Adjust button font size
      padding: "5px 8px", // Adjust button padding
    },
  },
  inputLabel: {
    // transform: "translate(14px, 16px) scale(1)", // Default alignment
    fontSize: "0.8rem", // Default font size
    transition: theme.transitions.create(["transform", "font-size"], {
      duration: theme.transitions.duration.shorter,
    }),
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.7rem", // Smaller font size for smaller screens
    },
    "@media (max-width: 1254px) and (max-height: 648px)": {
      fontSize: "0.6rem", // Specific font size for 1254×648 resolution
    },
  },
}));

const SummaryTable = ({ data }) => {

  const classes = useStyles();
  const [selectedPlaylists, setSelectedPlaylists] = useState({});
  const [dialogData, setDialogData] = useState(null); // Track dialog data
  const [mappingDialogOpen, setMappingDialogOpen] = useState(false);
  const [selectedMappingRow, setSelectedMappingRow] = useState(null);
  const [loading, setLoading] = useState(false);



  const fetchVideosFromPlaylist = async (state, county, town, playlistId, channel_type, channel_url) => {

    let fetchedVideos = [];
    setLoading(true);
    try {
      if (channel_url && playlistId === "live-channel") {
        const response1 = await axios.get(
          `${BACKEND_BASE_URL}/api/fetch-channel-id/`,
          { params: { url: channel_url } }
        );
        const encodedMunicipality = encodeURIComponent(town); // town maps to municipality
        const encodedChannelType = encodeURIComponent(channel_type);
        const response = await axios.get(
          `${BACKEND_BASE_URL}/api/playlist-summary/${state}/${county}/${encodedMunicipality}/${playlistId}-${response1.data.channel_id}/${encodedChannelType}/`,
          { params: { channel_url: channel_url } }
        );

        const videos = response.data;


        // Process the video data
        fetchedVideos = (Array.isArray(videos) ? videos : []).map((video) => ({
          title: video?.video_title,
          video_id: video?.video_id,
          url: `https://www.youtube.com/watch?v=${video?.video_id}`,
          published_at: video?.published_at,
          summaries: Array.isArray(video?.summaries) ? video.summaries : [],
        }));


      }
      else {
        const encodedMunicipality = encodeURIComponent(town); // town maps to municipality
        const encodedChannelType = encodeURIComponent(channel_type);
        const response = await axios.get(
          `${BACKEND_BASE_URL}/api/playlist-summary/${state}/${county}/${encodedMunicipality}/${playlistId}/${encodedChannelType}/`,
          { params: { channel_url: channel_url } }
        );

        const videos = response.data;


        // Process the video data
        fetchedVideos = (Array.isArray(videos) ? videos : []).map((video) => ({
          title: video?.video_title,
          video_id: video?.video_id,
          url: `https://www.youtube.com/watch?v=${video?.video_id}`,
          published_at: video?.published_at,
          summaries: Array.isArray(video?.summaries) ? video.summaries : [],
        }));

      }
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
    finally {
      setLoading(false)
    }
    return fetchedVideos;
  };

  const handlePlaylistChange = (rowId, selected) => {
    setSelectedPlaylists((prevState) => ({
      ...prevState,
      [rowId]: selected,
    }));
  };

  const handleDialogOpen = async (rowId) => {
    const row = data.find((row) => row.id === rowId);
    const selectedPlaylistNames = selectedPlaylists[rowId] || [];
    const selectedPlaylistObjects = row?.playlists;

    const videoFetchPromises = selectedPlaylistNames.map(
      async (playlistName) => {
        const playlist = selectedPlaylistObjects.find(
          (p) => p.playlist_name === playlistName,
        );
        if (playlist) {
          const videos = await fetchVideosFromPlaylist(
            row?.state,
            row?.county,
            row?.municipality_name,
            playlist?.playlist_id,
            row?.channel_type,
            row?.channel_url,

          );

          return { playlistName, videos };
        }
        return null;
      },
    );

    const results = await Promise.all(videoFetchPromises);

    const videoData = results.reduce((acc, result) => {
      if (result) acc[result.playlistName] = result.videos;
      return acc;
    }, {});

    setDialogData({
      rowId,
      selectedPlaylistNames,
      state: row?.state ?? "",
      county: row?.county ?? "",
      channel_url: row?.channel_url ?? "",
      associated_towns: row?.associated_towns,

      municipalityName: row?.municipality_name ?? "",
      channelName: row?.channel_name, // Use channel name from backend

      videos: videoData,
    });
  };

  const refreshDialogVideos = async () => {
    if (!dialogData?.rowId || !Array.isArray(dialogData?.selectedPlaylistNames)) return;
    const row = data.find((r) => r.id === dialogData.rowId);
    if (!row) return;

    const selectedPlaylistObjects = row?.playlists || [];
    setLoading(true);
    try {
      const videoFetchPromises = dialogData.selectedPlaylistNames.map(async (playlistName) => {
        const playlist = selectedPlaylistObjects.find((p) => p.playlist_name === playlistName);
        if (!playlist) return null;
        const videos = await fetchVideosFromPlaylist(
          row?.state,
          row?.county,
          row?.municipality_name,
          playlist?.playlist_id,
          row?.channel_type,
          row?.channel_url,
        );
        return { playlistName, videos };
      });

      const results = await Promise.all(videoFetchPromises);
      const videoData = results.reduce((acc, result) => {
        if (result) acc[result.playlistName] = result.videos;
        return acc;
      }, {});

      setDialogData((prev) => (prev ? { ...prev, videos: videoData } : prev));
    } catch (error) {
      console.error("Error refreshing dialog videos:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDialogClose = () => {
    setTimeout(() => {
      setDialogData(null);
    }, 100); // Delay of 100ms
  };


  const handleShowMapping = (row) => {
    setSelectedMappingRow(row);
    setMappingDialogOpen(true);
  };

  if (loading ) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="300px">
        <CircularProgress />
      </Box>
    );
  }
  return (
    <>
      <div className={classes.tableContainer}>
        <div className={classes.tableWrapper}>
          <Table className={`${classes.table} ${classes.responsiveTable}`}>
            <TableHead className={classes.header}>
              <TableRow>
                <TableCell className={classes.headerCell}>Country</TableCell>
                <TableCell className={classes.headerCell}>State</TableCell>
                <TableCell className={classes.headerCell}>County</TableCell>
                <TableCell className={classes.headerCell}>Town</TableCell>
                <TableCell className={classes.headerCell}>Channel Name</TableCell>
                <TableCell className={classes.headerCell}>Playlists</TableCell>
                <TableCell className={classes.headerCell}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell className={classes.responsiveCell}>{row.country}</TableCell>
                  <TableCell className={classes.responsiveCell}>{row.state}</TableCell>
                  <TableCell className={classes.responsiveCell}>{row.county}</TableCell>
                  <TableCell className={classes.responsiveCell}>{row.municipality_name}</TableCell>
                  <TableCell className={classes.responsiveCell}>
                    {row?.channel_name || "Unknown"} {/* Display channel name directly */}
                  </TableCell>
                  <TableCell className={classes.responsiveCell}>
                    {row?.playlists.length > 0 ? (
                      <FormControl fullWidth>
                        <InputLabel className={classes.inputLabel} >Select Playlists</InputLabel>
                        <Select
                          multiple
                          value={selectedPlaylists[row.id] || []}
                          onChange={(e) =>
                            handlePlaylistChange(row.id, e.target.value)
                          }
                          renderValue={(selected) => (
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {selected.map((value) => (
                                <Chip
                                  key={value}
                                  label={value === "Whole Channel" ? "Main Channel" : value}
                                  className={classes.chip}
                                  size="small"
                                />
                              ))}
                            </div>
                          )}
                        >
                          {row.playlists.map((playlist) => (
                            <MenuItem
                              key={playlist.playlist_id}
                              value={playlist.playlist_name}
                            >
                              <Checkbox
                                checked={(
                                  selectedPlaylists[row.id] || []
                                ).indexOf(playlist.playlist_name) > -1}
                              />
                              <ListItemText primary={playlist?.playlist_id === "whole-channel" ? "Main Channel" : playlist?.playlist_name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : (
                      <span>No Playlists</span>
                    )}
                  </TableCell>
                  <TableCell className={classes.responsiveCell}>
                    <Button
                      className={classes.responsiveButton}
                      variant="contained"
                      onClick={() => handleDialogOpen(row.id)}
                      style={{ marginTop: "10px", backgroundColor: "#0B194A", color: "white" }}
                    >
                      View Summary
                    </Button>

                    {row.last_scraped && (
                      <p style={{ fontSize: "11px" }}>
                        <b>Last Updated:</b> {row?.last_scraped}
                      </p>
                    )}

                    {row?.associated_towns?.length !== 0 && (
                      <p
                        style={{ fontSize: "11px", marginTop: "10px", cursor: "pointer", }}
                        onClick={() => handleShowMapping(row)}
                      >
                        <b>Show Mapping</b>
                      </p>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>

      <ShowMappingDialog
        open={mappingDialogOpen}
        onClose={() => setMappingDialogOpen(false)}
        rowData={selectedMappingRow}
      />

      {/* Video Dialog */}
      {dialogData && (
        <VedioDialog
          maxWidth="md"
          open={Boolean(dialogData)}
          onClose={handleDialogClose}
          state={dialogData?.state}
          county={dialogData?.county}
          municipalityName={dialogData?.municipalityName}
          channelName={dialogData?.channelName}
          videos={dialogData?.videos}
          channel_url={dialogData?.channel_url}
          associated_towns={dialogData?.associated_towns}
          onRefreshVideos={refreshDialogVideos}
        />
      )}
    </>
  );
};

export default SummaryTable;
